export const getTabsData = (canEdit: boolean) => {
  return [
    { label: 'Semana 1', disabled: !canEdit },
    { label: 'Semana 2', disabled: !canEdit },
    { label: 'Semana 3', disabled: !canEdit },
    { label: 'Semana 4', disabled: !canEdit },
    { label: 'Semana 5', disabled: !canEdit }
  ]
}
